import { mpHabilitado, MP_AMBIENTE, podeConectarMercadoPago, SITE_CONEXAO_MP, iniciarConexao, desconectarMercadoPago, mensagemMP } from "../../../utils/mercadoPago";
import {
  AMBIENTES, pagbankHabilitado, infinitepayHabilitado, podeConectarPagBank, SITE_CONEXAO_PAGBANK,
  iniciarConexaoPagBank, desconectarPagBank, removerInfiniteTag, mensagemPagamento,
} from "../../../utils/pagamentos";

/* Os provedores de pagamento (gateways) da tela Configurações → Pagamentos.
   Tudo o que muda de um para outro fica aqui: a tela só lê esta lista.
   Regra (garantida também no servidor — functions/pagamentos/gateways.js):
   UM provedor conectado por empresa. Trocar exige confirmação e o atual só
   sai depois que o novo terminar de conectar.

   termosVersao: sobe quando o que o usuário precisa saber antes de conectar
   muda (permissões, forma de recebimento). Quem já viu a versão atual
   reconecta sem esperar o contador. */

const data = ms => (ms ? new Date(ms).toLocaleDateString("pt-BR") : "—");

const PERMISSOES_PAGBANK = {
  "checkout.create": "Criar links de pagamento",
  "checkout.view": "Consultar os links criados",
  "checkout.update": "Cancelar um link quando você pedir",
  "payments.read": "Consultar se o pagamento foi feito",
};

export const GATEWAYS = [
  {
    id: "mercadopago", nome: "Mercado Pago", artigo: "o", sigla: "MP", cor: "#009ee3", resumo: "Pix e cartão online",
    termosVersao: 1, site: SITE_CONEXAO_MP,
    habilitado: () => mpHabilitado(), emBreve: () => false, emTeste: () => MP_AMBIENTE === "teste",
    podeConectarAqui: () => podeConectarMercadoPago(),
    conectar: opcoes => iniciarConexao(opcoes), desconectar: () => desconectarMercadoPago(), mensagemErro: mensagemMP,
    conta: s => s?.conta?.email || s?.conta?.apelido || null,
    antesDeConectar: [
      { icone: "carteira", texto: "O dinheiro das vendas cai direto na sua conta Mercado Pago." },
      { icone: "chave", texto: "Você entra e autoriza no site do Mercado Pago. O Print Control não vê nem guarda sua senha." },
      { icone: "recibo", texto: "Acesso concedido: criar cobranças Pix e de cartão e consultar se foram pagas." },
      { icone: "voltar", texto: "Você pode desconectar quando quiser, aqui em Pagamentos." },
    ],
    permissoes: () => ["Criar cobranças Pix e de cartão", "Consultar se o pagamento foi feito", "Renovar a autorização sem pedir de novo"],
    seguranca: [
      "Autorização pelo OAuth oficial do Mercado Pago (com PKCE e state de uso único, válido por 10 minutos).",
      "Credenciais guardadas só no servidor, cifradas (AES-256-GCM); a chave fica num gerenciador de segredos, separada do banco.",
      "Notificações do Mercado Pago aceitas só com assinatura válida; o pagamento é consultado de novo na API antes de o pedido virar pago.",
      "Cartão digitado no formulário do próprio Mercado Pago: número e CVV não passam pelo Print Control.",
    ],
    linhasConta: s => [
      ["Conta", s?.conta?.apelido || "—"], ["E-mail", s?.conta?.email || "—"], ["Conectada em", data(s?.conectadoEm)],
      ["Autorização válida até", data(s?.expiraEm)], ["Renovação automática", s?.renovavel ? "Sim, antes de vencer" : "Não — reconecte antes do vencimento"],
      ["ID da conta", s?.conta?.id || "—"],
    ],
    notaDesconectar: "Para revogar também a autorização, remova o Print Control das aplicações autorizadas na sua conta Mercado Pago.",
  },
  {
    id: "pagbank", nome: "PagBank", artigo: "o", sigla: "PB", cor: "#1a9e5c", resumo: "Pix e cartão online",
    termosVersao: 1, site: SITE_CONEXAO_PAGBANK,
    // Fora do ar em produção enquanto o PagBank não homologa a aplicação (netlify.toml)
    habilitado: () => pagbankHabilitado(), emBreve: () => !pagbankHabilitado(), emTeste: () => AMBIENTES.pagbank === "sandbox",
    podeConectarAqui: () => podeConectarPagBank(),
    conectar: opcoes => iniciarConexaoPagBank(opcoes), desconectar: () => desconectarPagBank(), mensagemErro: mensagemPagamento,
    conta: s => s?.conta?.id || null,
    antesDeConectar: [
      { icone: "carteira", texto: "O dinheiro das vendas cai direto na sua conta PagBank." },
      { icone: "chave", texto: "Você entra e autoriza no site do PagBank. O Print Control não vê nem guarda sua senha." },
      { icone: "recibo", texto: "Acesso concedido: criar e cancelar links de pagamento e consultar se foram pagos. Sem estorno e sem acesso aos seus dados cadastrais." },
      { icone: "voltar", texto: "Você pode desconectar quando quiser; a autorização também é revogada no PagBank." },
    ],
    permissoes: s => (Array.isArray(s?.escopos) && s.escopos.length ? s.escopos : Object.keys(PERMISSOES_PAGBANK)).map(e => PERMISSOES_PAGBANK[e] || e),
    seguranca: [
      "Autorização pelo PagBank Connect, com state de uso único válido por 10 minutos.",
      "Credenciais guardadas só no servidor, cifradas (AES-256-GCM); a chave fica num gerenciador de segredos, separada do banco.",
      "Notificações aceitas só com a assinatura oficial do PagBank; o pagamento é relido na API antes de o pedido virar pago.",
      "Pix e cartão são pagos na página do PagBank: dados do cartão não passam pelo Print Control.",
    ],
    linhasConta: s => [
      ["Conta PagBank", s?.conta?.id || "—"], ["Conectada em", data(s?.conectadoEm)],
      ["Autorização", s?.expiraEm ? `válida até ${data(s.expiraEm)}` : "renovada automaticamente"],
    ],
    notaDesconectar: "A autorização é revogada no PagBank ao desconectar.",
  },
  {
    id: "infinitepay", nome: "InfinitePay", artigo: "a", sigla: "IP", cor: "#7c3aed", resumo: "Pix e cartão em até 12x",
    termosVersao: 1, site: null, pedeTag: true,
    habilitado: () => infinitepayHabilitado(), emBreve: () => !infinitepayHabilitado(), emTeste: () => true,
    podeConectarAqui: () => true,
    conectar: null, desconectar: () => removerInfiniteTag(), mensagemErro: mensagemPagamento,
    conta: s => s?.handle || null,
    antesDeConectar: [
      { icone: "carteira", texto: "O dinheiro cai na conta dona da InfiniteTag que você informar." },
      { icone: "alerta", texto: "A InfinitePay não oferece login para plataformas: confira a tag com cuidado, porque o Print Control não consegue confirmar quem é o dono." },
      { icone: "recibo", texto: "O Print Control só cria links de pagamento e confirma os pagamentos." },
      { icone: "voltar", texto: "Você pode desativar quando quiser, aqui em Pagamentos." },
    ],
    permissoes: () => ["Criar links de pagamento com a sua InfiniteTag", "Consultar se o pagamento foi feito"],
    seguranca: [
      "Sem senha e sem token: a InfinitePay identifica a conta só pela InfiniteTag.",
      "Cada link tem uma notificação com segredo próprio, e o pagamento é confirmado na consulta oficial da InfinitePay (payment_check).",
      "Valor e transação são conferidos no servidor; uma transação nunca quita duas cobranças.",
    ],
    linhasConta: s => [["InfiniteTag", s?.handle || "—"], ["Situação", s?.verificada ? "Verificada" : "Aguardando verificação"]],
    notaDesconectar: "Links já enviados continuam valendo na InfinitePay.",
  },
];

// "o Mercado Pago", "a InfinitePay"
export const comArtigo = gw => `${gw.artigo} ${gw.nome}`;

export const gatewayPorId = id => GATEWAYS.find(g => g.id === id) || null;

/* Estado de um provedor para a tela:
   carregando · disponivel · conectado · reconectar · em_breve */
export function estadoDoGateway(gw, status) {
  if (gw.emBreve()) return "em_breve";
  if (status === undefined) return "carregando";
  if (gw.id === "infinitepay") return status?.configurada ? "conectado" : "disponivel";
  if (status?.conectado) return "conectado";
  if (status?.precisaReconectar) return "reconectar";
  return "disponivel";
}

// Conectado ou esperando reconexão: ocupa o lugar de provedor da empresa
export const ocupaLugar = estado => estado === "conectado" || estado === "reconectar";

// Já viu os termos desta versão? (então reconecta sem esperar o contador)
export const termosAceitos = (gw, status) => Number(status?.termosVersao) >= gw.termosVersao;
